/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import Head from "next/head";

export type GTMProps = {
  enabled?: boolean;
  containerId?: string;
};

export const GTM = ({ enabled, containerId }: GTMProps = {}) => {
  if (!enabled || !containerId) {
    return null;
  }

  return (
    <>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${containerId}');`,
          }}
        ></script>
      </Head>
      <noscript>
        <iframe
          src={`//www.googletagmanager.com/ns.html?id=${containerId}`}
          height="0"
          width="0"
          style={{
            display: "none",
            visibility: "hidden",
          }}
        />
      </noscript>
    </>
  );
};
